export const CellWarningIcon = (
  <svg
    aria-hidden
    height="1em"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.6188 0L9.2376 8H0L4.6188 0Z" />
  </svg>
);

export const CellErrorIcon = (
  <svg
    aria-hidden
    width="1em"
    height="1em"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="4" cy="4" r="4" />
  </svg>
);

export const CellSuccessIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7668 2.63645L5.06034 12.0309L0.277532 7.56074L1.47248 6.28223L4.97136 9.55242L12.4832 1.4469L13.7668 2.63645Z"
      fill="#24874B"
    />
  </svg>
);
